import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { getCategorias, deleteCategoria, getSegmentosCategoria, adminCategoriaSegmento, mergeCategoria } from "Services/temas_service";
import { fileUri } from "Constantes/constants";
import { UploadFileS3 } from "Slices/File/fileSlice";
import { getSegmentos } from "Services/segmento_service";
import { setSegmentos } from "Slices/Segmento/segmentoSlice";
import { storageService } from "Services/storage_service";

const initialState = {
    categorias: [],
    categoria: {
        idCategoria: 0,
        nombre: '',
        icono: '',
        orden: 0,
        idSegmento: 1,
        estado: 1,
        usuario: '',
    },
    img: '',
    file: null,
    categoriasSeleccionadas: [],
    segmentosAsignados: [],
};


export const categoriaSlice = createSlice({
    name: 'categoria',
    initialState,
    reducers: {
        setCategorias: (state, action) => {
            state.categorias = action.payload;
        },
        setCategoriasSeleccionadas: (state, action) => {
            state.categoriasSeleccionadas = action.payload;
        },
        setCategoriaSegmentos: (state, action) => {
            state.segmentosAsignados = action.payload;
        },
        setCategoria: (state, action) => {
            state.categoria = action.payload;
        },
        updateCategoriaField: (state, action) => {
            const { name, value } = action.payload;
            state.categoria[name] = value;
        },
        setIconoCategoria: (state, action) => {
            state.categoria.icono = action.payload;
        },
        setFile: (state, action) => {
            state.file = action.payload;
        },
        setImgPreview: (state, action) => {
            state.img = action.payload;
        },
        resetCategoria: (state) => {
            state.categoria = {
                idCategoria: 0,
                nombre: '',
                icono: '',
                orden: 0,
                idSegmento: 1,
                estado: 1,
                usuario: '',
            };
            state.img = '';
            state.file = null;
            state.segmentosAsignados = [];
        },
    }
});

export const fetchCategorias = createAsyncThunk(
    'categoria/fetchCategoria',
    async (data, { dispatch }) => {
        const categoriaRes = await getCategorias(data);
        dispatch(setCategorias(categoriaRes));
    }
);

export const adminCategoria = createAsyncThunk(
    'categoria/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const user = storageService.getItem('user');
        const categoriaRes = await mergeCategoria(data);
        if (categoriaRes.result === 1)
            await adminCategoriaSegmento({ idCategoria: categoriaRes.data, segmentos: data.segmentos });
        
        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file);
            formData.append('tipo', fileUri.portada);
            formData.append('name', `cat_${categoriaRes.data}.jpg`);
            console.log(formData);
            await dispatch(UploadFileS3(formData));
        }
        
        dispatch(setResponse(categoriaRes));
        dispatch(setModal(false));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
        
        dispatch(setCategoria(initialState.categoria));
        if (user.codSegmento) {
            dispatch(fetchCategorias({ codSegmento: user.codSegmento }));
        }
        else {
            dispatch(fetchCategorias({ codSegmento: null }));
        }
        dispatch(setLoading(false));
    }
);

export const DisableCategoria = createAsyncThunk(
    'categoria/delete',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const categoriaRes = await deleteCategoria(data);
        console.log(categoriaRes);
        dispatch(setResponse(categoriaRes));
        dispatch(setLoading(false));
        dispatch(setToast(true));
        dispatch(fetchCategorias());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const fetchSegmentosCategoria = createAsyncThunk(
    'categoria/fetchSegmentosCategirua',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const segmentoRes = await getSegmentos();
        const asignadosRes = await getSegmentosCategoria(data);
        dispatch(setSegmentos(segmentoRes));
        dispatch(setCategoriaSegmentos(asignadosRes ?? []));
        dispatch(setLoading(false));
    }
);

export const { setCategorias, setCategoria, setCategoriasSeleccionadas, setCategoriaSegmentos, setIconoCategoria, setFile, setImgPreview, resetCategoria, updateCategoriaField } = categoriaSlice.actions;
export default categoriaSlice.reducer;